import { Injectable } from "@angular/core";
import { UserDetails } from "../models/user.model";

@Injectable()
export class CommonService {
  initialOnboardingState: string = "initial";
  extendedOnboardingState: string = "extended";
  subTierOnboardingState: string = "subtier";
  reactivationState: string = "reactivation";
  entityExtensionState: string = "EntityExtension";
  nameTinChangeState: string = "NameOrTINChange";

  get supplierCodeRegex(): RegExp {
    return /[0-9]{6}/g
  }

  getSupplierCode(urlSupplier: string): string {
    const result = urlSupplier.match(this.supplierCodeRegex);
    return result === null ? null : result[0];
  }

  getProfileTab(tab: string): string {
    let transformTab = tab.toLowerCase();
    transformTab = transformTab.charAt(0).toUpperCase() + transformTab.slice(1);
    return transformTab;
  }

  checkOnboardingState(userDetails: UserDetails, supplierCode: string, state: string) {
    if (userDetails.isTeslaUser) {
      return false;
    }
    let selectedSupplierMap = userDetails.supplierContact.supplierMaps.find(x => x.supplierCode == supplierCode);
    if (!selectedSupplierMap) {
      return false;
    }

    return selectedSupplierMap.supplierState.toLowerCase() == state.toLowerCase();
  }

  isExtendedOnboardingState(userDetails: UserDetails, supplierCode: string) {
    return this.checkOnboardingState(userDetails, supplierCode, this.extendedOnboardingState);
  }

  isInitialOnboardingState(userDetails: UserDetails, supplierCode: string) {
    return this.checkOnboardingState(userDetails, supplierCode, this.initialOnboardingState);
  }

  isSubTierOnboardingState(userDetails: UserDetails, supplierCode: string) {
    return this.checkOnboardingState(userDetails, supplierCode, this.subTierOnboardingState);
  }

  isReactivationState(userDetails: UserDetails, supplierCode: string) {
    return this.checkOnboardingState(userDetails, supplierCode, this.reactivationState);
  }

  isEntityExtensionState(userDetails: UserDetails, supplierCode: string) {
    return this.checkOnboardingState(userDetails, supplierCode, this.entityExtensionState);
  }

  isNameTinChangeState(userDetails: UserDetails, supplierCode: string) {
    return this.checkOnboardingState(userDetails, supplierCode, this.nameTinChangeState);
  }

  allowToRerouteToPostOnboarding(userDetails: UserDetails, supplierCode: string) {
    return this.isEntityExtensionState(userDetails, supplierCode) || this.isSubTierOnboardingState(userDetails, supplierCode)
      || this.isNameTinChangeState(userDetails, supplierCode);
  }

  getRouteFromSupplierState(userDetails: UserDetails, supplierCode: string) {
    const hasOnboardingTasks = userDetails?.supplierContact?.supplierMaps.find(x => x.supplierCode == supplierCode)?.hasOnboardingTasks;
    const isInitialOnboarding = this.isInitialOnboardingState(userDetails, supplierCode);
    const isExtendedOnboarding = this.isExtendedOnboardingState(userDetails, supplierCode);
    const isSubTierOnboarding = this.isSubTierOnboardingState(userDetails, supplierCode);
    const isEntityExtension = this.isEntityExtensionState(userDetails, supplierCode);
    const isReactivation = this.isReactivationState(userDetails, supplierCode);

    switch (true) {
      case isInitialOnboarding && hasOnboardingTasks:
        return [`${supplierCode}`, "Onboarding", "Home"];
      case isInitialOnboarding && !hasOnboardingTasks:
        return [`${supplierCode}`, "Onboarding", "Initial"];
      case isExtendedOnboarding && hasOnboardingTasks:
        return [`${supplierCode}`, "Onboarding", "Home"];
      case isExtendedOnboarding && !hasOnboardingTasks:
        return [`${supplierCode}`, "Onboarding", "Extended"];
      case isSubTierOnboarding:
        return [`${supplierCode}`, "Onboarding", "Home"];
      case isReactivation:
        return [`${supplierCode}`, "Reactivation", "Home"]; 
      default:
        return [`${supplierCode}`];
    }
  }

  getPossibleRouteFromSupplierState(userDetails: UserDetails, supplierCode: string): string[][] {
    const hasOnboardingTasks = userDetails?.supplierContact?.supplierMaps.find(x => x.supplierCode == supplierCode)?.hasOnboardingTasks;
    const isInitialOnboarding = this.isInitialOnboardingState(userDetails, supplierCode);
    const isExtendedOnboarding = this.isExtendedOnboardingState(userDetails, supplierCode);
    const isSubTierOnboarding = this.isSubTierOnboardingState(userDetails, supplierCode);
    const isEntityExtension = this.isEntityExtensionState(userDetails, supplierCode);
    const isNameTinChange = this.isNameTinChangeState(userDetails, supplierCode);
    const isReactivation = this.isReactivationState(userDetails, supplierCode);

    let res = [];
    if((hasOnboardingTasks && !isReactivation) || isSubTierOnboarding || isEntityExtension || isNameTinChange) res.push([`${supplierCode}`, "Onboarding", "Home"]);
    if(isInitialOnboarding) res.push([`${supplierCode}`, "Onboarding", "Initial"]);
    if(isExtendedOnboarding) res.push([`${supplierCode}`, "Onboarding", "Extended"]);
    if(isNameTinChange) res.push([`${supplierCode}`, "Onboarding", "Extended"]);
    if(isReactivation) res.push([`${supplierCode}`, "Reactivation", "Home"]);
    if(!isInitialOnboarding && !isExtendedOnboarding && !isSubTierOnboarding && !isReactivation) res.push([`${supplierCode}`]);
    return res;
  }
}
